import Lottie from 'lottie-react';

import animation from 'components/Loading/animation.json';

import * as S from './styles';

const LoadingPage: React.FC = () => {
  return (
    <S.LoadingPageContainer data-testid="loadingPage">
      <S.LogoContainer>
        <Lottie animationData={animation} width={128} />
      </S.LogoContainer>
    </S.LoadingPageContainer>
  );
};

export default LoadingPage;
